import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { RTLProps } from '@/shared/prop-types/ReducerProps';

export const DdoColumns = [
  {
    id: 'id',
    label: 'Id',
    disablePadding: true,
  },
  {
    id: 'ddoProgramTitle',
    label: 'Program Title',
    disablePadding: true,
  },
  {
    id: 'organizationName',
    label: 'Organization Name',
    disablePadding: true,
  },
  {
    id: 'ddoStartdate',
    label: 'Start Date',
    disablePadding: true,
  },
  {
    id: 'ddoEnddate',
    label: 'End Date',
    disablePadding: true,
  },
  {
    id: 'status',
    label: 'Status',
    disablePadding: true,
  },
  {
    id: 'action',
    label: 'Action',
  },
];

const createSortHandler = (property, onRequestSort) => (event) => {
  onRequestSort(event, property);
};

const DdoTableColumns = ({ order, orderBy, rtl, onRequestSort }) => (
  <Fragment>
    <TableRow>
      {DdoColumns.map((row) => (
        <TableCell
          className="material-table__cell material-table__cell--sort material-table__cell-center"
          key={row.id}
          align={'center'}
          padding={row.disablePadding ? 'none' : 'default'}
          sortDirection={orderBy === row.id ? order : false}
        >
          <TableSortLabel
            active={orderBy === row.id}
            direction={order}
            onClick={createSortHandler(row.id, onRequestSort)}
            className="material-table__sort-label"
            dir="ltr"
          >
            <b>{row.label}</b>
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  </Fragment>
);

DdoTableColumns.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rtl: RTLProps.isRequired,
};

export default connect((state) => ({
  rtl: state.rtl,
}))(DdoTableColumns);
